import { render, staticRenderFns } from "./BasMaterialModal__Style#Drawer.vue?vue&type=template&id=2d3c4242&scoped=true&"
import script from "./BasMaterialModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BasMaterialModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BasMaterialModal__Style#Drawer.vue?vue&type=style&index=0&id=2d3c4242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c4242",
  null
  
)

export default component.exports